/**
 * Katerina Art — Scroll Reveal Animations
 * Re-initializes reveal observers for dynamically loaded sections
 */
(function () {
  'use strict';

  function initReveal() {
    if (typeof katerina !== 'undefined' && katerina.initReveal) {
      katerina.initReveal();
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Re-run when Shopify Theme Editor loads a section
  document.addEventListener('shopify:section:load', initReveal);
})();
